<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div id="organTripReport" class="modal fade" aria-hidden="true" aria-labelledby="organTripReportlabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button">
                    <i class="fa fa-close"></i>
                </button>
                <h4 class="modal-title" style="color: white !important">Trip Report</h4>
            </div>

            <div id="tripReport-section" class="modal-body">
                <div id="organ">
                    <div class="px-0">
                        <div class="border-bottom row mx-1 vermilion">
                            <div class="col-md-11">
                                <h4 class="vermilion custom-header font-medium margin heading text-center">TRIP REPORT</h4>
                            </div>
                            <div>
                                <button
                                    *ngIf="!isInternalReadOnly"
                                    id="download-trip-report"
                                    class="message-icon m-0"
                                    data-dismiss="modal"
                                    ngxPrint
                                    printSectionId="tripReport-section"
                                    [useExistingCss]="true"
                                >
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row bg-light custom-color mx-0">
                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b>UNOS ID</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                {{ reportDetails?.unos }}
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b>TRIP #</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                {{ reportDetails?.tripID }}
                            </div>

                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1 d-h">
                                <b> DONOR HOSPITAL</b>
                            </div>
                            <div class="col-md-9 col-sm-6 col-xs-9 pl-1 mt-1 honor-hospital-details">
                                {{ reportDetails?.source }}
                                {{ reportDetails?.sourceAddress }}
                                {{ reportDetails?.sourceAddressLocation }}
                            </div>

                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b>SERVICE REQUEST</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                {{ reportDetails?.serviceType }}
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b>TIME OF CALL FOR REQUEST</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1 time-of-call-for-request">
                                {{ reportDetails?.createdOn | localDate: timeZone }}
                            </div>

                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b>SCHEDULED P/U TIME</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                {{ reportDetails?.actualDate | localDate: timeZone }}
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                <b> ARRIVAL @ DESTINATION</b>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1 arrival-destination">
                                <span *ngIf="reportDetails?.status == 'Completed'">
                                    {{ reportDetails?.actualEndTime | localDate: timeZone }}</span
                                >
                                <span *ngIf="reportDetails?.status != 'Completed'"> 00 h 00 m</span>
                            </div>

                            <div class="row mx-0">
                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <!-- ESTIMATED SOURCE TO DESTINATION -->
                                    <b>ESTIMATED OUTBOUND D2D</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-3">
                                    {{ estimatedSourceTime | hourMinConvertion }}
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <!-- ACTUAL SOURCE TO DESTINATION -->
                                    <b>ACTUAL OUTBOUND D2D</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-3">
                                    {{ actualSourceTime | hourMinConvertion }}
                                </div>
                            </div>

                            <div class="row mx-0">
                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <!-- ESTIMATED DESTINATION TO SOURCE -->
                                    <b>ESTIMATED INBOUND D2D</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-3">
                                    {{ estimatedDestinationTime | hourMinConvertion }}
                                </div>

                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <!-- ACTUAL DESTINATION TO SOURCE -->
                                    <b> ACTUAL INBOUND D2D</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-3">
                                    {{ actualDestinationTime | hourMinConvertion }}
                                </div>
                            </div>
                            <div class="row mx-0">
                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <b>TOTAL TRIP TIME</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-3">
                                    {{ doorToDoorTime | hourMinConvertion }}
                                </div>

                                <div class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <b>ACTUAL DOOR-TO-DOOR</b>
                                </div>
                                <div class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                    {{ actualDoorToDoorTime | hourMinConvertion }}
                                </div>
                            </div>

                            <div class="row mx-0">
                                <div *ngIf="reportDetails?.serviceType == 'Organ'" class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <b>ORGAN PROCURED</b>
                                </div>
                                <div *ngIf="reportDetails?.serviceType == 'Organ'" class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                    {{ reportDetails?.serviceSubType }}
                                </div>
                                <div
                                    *ngIf="reportDetails?.serviceType == 'Organ' || reportDetails?.serviceType == 'Team'"
                                    class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1"
                                >
                                    <b>SCHEDULED OR TIME</b>
                                </div>
                                <div
                                    *ngIf="reportDetails?.serviceType == 'Organ' || reportDetails?.serviceType == 'Team'"
                                    class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1"
                                >
                                    {{ reportDetails?.createdOn | localDate: timeZone }}
                                </div>
                                <div *ngIf="reportDetails?.serviceType == 'Equipment'" class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <b>EQUIPMENT TYPE</b>
                                </div>
                                <div *ngIf="reportDetails?.serviceType == 'Equipment'" class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                    {{ reportDetails?.serviceSubType }}
                                </div>
                                <div *ngIf="reportDetails?.serviceType == 'Specimen'" class="col-md-3 col-sm-6 col-xs-3 bg-navy pl-1 mt-1">
                                    <b> SPECIMEN TYPE</b>
                                </div>
                                <div *ngIf="reportDetails?.serviceType == 'Specimen'" class="col-md-3 col-sm-6 col-xs-3 pl-1 mt-1">
                                    {{ reportDetails?.serviceSubType }}
                                </div>
                            </div>
                        </div>

                        <!-- <div class="my-3">
              <h3 class="ml-2 mt-3 text-danger less-margin">
                <span class="font-medium custom-header">TRIP OVERVIEW</span>
              </h3>
              <div class="mx-2 p-2 textbox">
                Summary of organ trip and any details for delays,incidents,etc.....
              </div>
            </div> -->

                        <div class="mt-3">
                            <h3 class="vermilion custom-header font-medium margin border-bottom heading">TAM - TRIP TIME DETAILS</h3>
                            <table class="table bg-table custom-border m-0 p-0">
                                <thead>
                                    <tr class="bg-cardinal text-white">
                                        <th class="bg-cardinal th-table"><b>Travel Sector</b></th>
                                        <th class="bg-cardinal th-table" scope="col" style="text-align: center">
                                            <b>Date & Time</b>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody *ngFor="let leg of reportDetails?.legDetails" class="th-bg report">
                                    <tr *ngIf="leg.transportType == 'Ground'">
                                        <th>
                                            SCHEDULED DRIVER IN PLACE @ {{ leg.origin }} {{ leg.originAddress }}
                                            {{ leg?.originAddressLocation }}
                                        </th>
                                        <td class="text-center">
                                            <span *ngIf="leg?.groudLegTimeStamp?.plannedStartTime != null">{{
                                                leg?.groudLegTimeStamp?.plannedStartTime | localDate: timeZone
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="leg.transportType == 'Ground'">
                                        <th>DRIVER ON SCENE @ {{ leg.origin }} {{ leg.originAddress }} {{ leg?.originAddressLocation }}</th>
                                        <td class="text-center">
                                            <span *ngIf="leg?.groudLegTimeStamp?.onsceneTime != null">{{
                                                leg?.groudLegTimeStamp?.onsceneTime | localDate: timeZone
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="leg.transportType == 'Ground'">
                                        <th>ACTUAL PICKED UP TIME</th>
                                        <td class="text-center">
                                            <span *ngIf="leg?.groudLegTimeStamp?.pickedUpTime != null">{{
                                                leg?.groudLegTimeStamp?.pickedUpTime | localDate: timeZone
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="leg.transportType == 'Ground'">
                                        <th>
                                            DROP AT @ {{ leg.destination }}
                                            {{ leg.destinationAddress }}
                                            {{ leg?.destinationAddressLocation }}
                                        </th>
                                        <td class="text-center">
                                            <span
                                                *ngIf="
                                                    leg?.groudLegTimeStamp?.completedStartTime != null &&
                                                    (leg.status == 'Dropped Off' || leg.status == 'Driver Done' || leg.status == 'Job Done')
                                                "
                                                >{{ leg?.groudLegTimeStamp?.completedStartTime | localDate: timeZone }}</span
                                            >
                                        </td>
                                    </tr>

                                    <tr *ngIf="leg.transportType == 'Air'">
                                        <th>SCHDULED PLANE ON STANDBY</th>
                                        <td class="text-center">
                                            <span *ngIf="leg?.airLegTimeStamp?.plannedStartTime != null">{{
                                                leg?.airLegTimeStamp?.plannedStartTime | localDate: timeZone
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="leg.transportType == 'Air'">
                                        <th>ACTUAL WHEELS UP</th>
                                        <td class="text-center">
                                            <span *ngIf="leg?.airLegTimeStamp?.wheelsUpTime != null">{{
                                                leg?.airLegTimeStamp?.wheelsUpTime | localDate: timeZone
                                            }}</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="leg.transportType == 'Air'">
                                        <th>WHEELS DOWN</th>
                                        <td class="text-center">
                                            <span
                                                *ngIf="
                                                    leg?.airLegTimeStamp?.completedStartTime != null &&
                                                    (leg.status == 'Landed' || leg.status == 'Driver Done' || leg.status == 'Job Done')
                                                "
                                                >{{ leg?.airLegTimeStamp?.completedStartTime | localDate: timeZone }}</span
                                            >
                                        </td>
                                    </tr>
                                    <!-- <tr>
                    <th>WHEELS DOWN</th>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <th>DRIVER ON SCENE AT AIRPORT</th>
                    <td>{{reportDetails?.DriverName}}</td>
                    <td></td>
                  </tr>

                  <tr>
                    <th>ORGAN ONBOARD TO TRANSPLANT CENTER</th>
                    <td>{{reportDetails?.OrganInHandToHospital}}</td>
                    <td></td>
                  </tr>

                  <tr>
                    <th>ORGAN DROP - TRANSFER CENTER</th>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <th>TRAVEL TIME RETURN</th>
                    <td>{{reportDetails?.TotalTravelTimeWithOrgan}}</td>
                    <td></td>
                  </tr> -->

                                    <!-- <tr>
                    <th>VARIANCE</th>
                    <td></td>
                    <td></td>
                  </tr> -->
                                </tbody>

                                <tbody class="th-bg report">
                                    <tr>
                                        <th>TOTAL TRIP TIME</th>
                                        <td class="text-center">{{ doorToDoorTime | hourMinConvertion }} Min</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
